import tw from "twin.macro"
import styled from "@emotion/styled/macro"

import { StyledColumn } from "../../Styled/Column"
import { StyledRow } from "../../Styled/Row"
import { StyledIndicators } from "../../Styled/Indicator"
import { StyledLink } from "../../Styled/Button"
import { Blockquote } from "../../Styled/Text"

export const Section = tw.section`relative flex items-center justify-center bg-navy-dark overflow-hidden`
export const Image = styled.div`
  ${tw`invisible opacity-0 transition-all pointer-events-none duration-500`}
  ${({ active }) => active && tw`opacity-100 visible`}

  &,
  > * {
    ${tw`inset-x-0 top-0 bottom-1/2`}
    position: absolute !important;

    > * {
      ${tw`bottom-0`}
    }

    @media (min-width: 768px) {
      ${tw`inset-0`}
    }
  }
`

export const Gradient = tw.div`absolute inset-x-0 top-0 bottom-1/2 md:bottom-0 bg-gradient-to-b md:bg-gradient-to-r from-transparent to-navy-dark`
export const Button = styled(StyledLink)`
  ${tw`absolute text-white z-1 bottom-0 md:bottom-auto mb-8 md:mb-0`}
  ${({ position }) => (position === `Right` ? tw`right-0 mr-8` : tw`left-0 ml-8`)}
`
export const Indicators = tw(StyledIndicators)`absolute bottom-0 mb-10 md:mb-8 z-1`
export const Item = tw(StyledRow)`text-white pb-24 md:pb-0 md:px-12 md:min-h-150`
export const Column = tw(StyledColumn)`flex flex-col items-start justify-end md:block min-h-80 md:min-h-0`
export const Content = tw.div`w-full md:w-1/2`
export const Quote = tw(Blockquote)`mt-8 md:mt-5 mb-8 md:mb-12`
